/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { Typography } from "@mui/material";
import { userHasRole } from "../../backofficeUserService";
import { BackofficeUser, Roles } from "../../../types/BackofficeUser";
import { LitigationUnion } from "../../../types/LitigationUnion";

export const litigationCaseSubBarAdditionalInformation = <T extends LitigationUnion = LitigationUnion>(
  product: T,
  currentUser: BackofficeUser
) => {
  const valueInDispute =
    product.valueInDisputeJudicialFinal ??
    product.valueInDisputeJudicialPreliminary ??
    product.valueInDisputeExtrajudicialFinal ??
    product.valueInDisputeExtrajudicialPreliminary;

  if (!valueInDispute) {
    return null;
  }

  if (
    userHasRole(currentUser, Roles.callcenter) ||
    !(product.caseCategory === "enforceClaim" || product.caseCategory === "defendClaim") ||
    valueInDispute <= 10000
  ) {
    return null;
  }

  return (
    <Typography>
      <strong>
        Streitwert:{" "}
        {valueInDispute.toLocaleString("de-DE", {
          style: "currency",
          currency: "EUR",
        })}
      </strong>
    </Typography>
  );
};
